
export default {
  name: 'HomeDeals',
  props: {
    deals: {
      type: Array,
      default: () => [],
    },
  },
}
